module.exports = __webpack_public_path__ + "static/img/蔚来ET7行政版.8f4d110e.png";